/*
 * Copyright (c) 2020 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

export class TimeClockFormatKey {
  static readonly LONG_DATE = 'time-clock/format/long-date';
  static readonly TIME = 'time-clock/format/time';
}
